import { SvgIconProps } from "@mui/material";
import {
  ApprovedIcon,
  CancelIcon,
  PendingIcon,
} from "../../../components/MuiIcons";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { mainTheme } from "../../../theme/mainTheme";

const finalReviewColor = mainTheme.palette.augmentColor({
  color: {
    main: "#FF8C00",
  },
}).main;

export enum VerificationStatus {
  NEW = "NEW",
  SENT_TO_VERIFICATION = "SENT_TO_VERIFICATION",
  INFORMATION_REQUESTED = "INFORMATION_REQUESTED",
  ON_FINAL_REVIEW = "ON_FINAL_REVIEW",
  ACCEPTED = "ACCEPTED",
  CANCELED = "CANCELED",
  REJECTED = "REJECTED",
  DELETED = "DELETED",
}

export const RETURN_TO_REVISION = "return_for_revision";

const {
  NEW,
  SENT_TO_VERIFICATION,
  ON_FINAL_REVIEW,
  INFORMATION_REQUESTED,
  ACCEPTED,
  CANCELED,
  REJECTED,
  DELETED,
} = VerificationStatus;

const informationRequestedIconColor = mainTheme.palette.info.main;

const InformationRequestedIcon = (props: SvgIconProps) => {
  const { sx } = props;
  const iconProps = { ...props };
  const style = iconProps.style;

  delete iconProps.color;
  delete iconProps.fill;
  delete iconProps.htmlColor;
  delete iconProps.style;
  delete iconProps.sx;

  return (
    <InfoOutlinedIcon
      {...iconProps}
      htmlColor={informationRequestedIconColor}
      style={
        style
          ? { ...style, color: informationRequestedIconColor }
          : undefined
      }
      sx={[
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        { color: informationRequestedIconColor },
      ]}
    />
  );
};

export const statusIcons: Record<VerificationStatus, React.FC<SvgIconProps>> = {
  [NEW]: (props: SvgIconProps) => <PendingIcon {...props} />,
  [SENT_TO_VERIFICATION]: (props: SvgIconProps) => <PendingIcon {...props} />,
  [ON_FINAL_REVIEW]: (props: SvgIconProps) => <PendingIcon {...props} />,
  [ACCEPTED]: (props: SvgIconProps) => <ApprovedIcon {...props} />,
  [CANCELED]: (props: SvgIconProps) => <CancelIcon {...props} />,
  [REJECTED]: (props: SvgIconProps) => <CancelIcon {...props} />,
  [DELETED]: (props: SvgIconProps) => (
    <DeleteIcon sx={{ height: 20, color: props.color }} {...props} />
  ),
  [INFORMATION_REQUESTED]: InformationRequestedIcon,
};

export const statusesModel: Record<
  VerificationStatus,
  { bgColor: string; name: string; textColor: string }
> = {
  [NEW]: {
    bgColor: `${mainTheme.palette.primary.main}1A`,
    name: "New",
    textColor: mainTheme.palette.primary.main,
  },
  [SENT_TO_VERIFICATION]: {
    bgColor: `${mainTheme.palette.warning.main}1A`,
    name: "Sent to verification",
    textColor: mainTheme.palette.warning.main,
  },
  [ON_FINAL_REVIEW]: {
    bgColor: `${finalReviewColor}1A`,
    name: "On Final Review",
    textColor: finalReviewColor,
  },
  [ACCEPTED]: {
    bgColor: `${mainTheme.palette.success.main}1A`,
    name: "Accepted",
    textColor: mainTheme.palette.success.main,
  },
  [CANCELED]: {
    bgColor: `${mainTheme.palette.error.main}1A`,
    name: "Rejected",
    textColor: mainTheme.palette.error.main,
  },
  [REJECTED]: {
    bgColor: `${mainTheme.palette.error.main}1A`,
    name: "Rejected",
    textColor: mainTheme.palette.error.main,
  },
  [DELETED]: {
    bgColor: `${mainTheme.palette.error.main}1A`,
    name: "Deleted",
    textColor: mainTheme.palette.error.main,
  },
  [INFORMATION_REQUESTED]: {
    bgColor: `${mainTheme.palette.info.main}1A`,
    name: "Information requested",
    textColor: mainTheme.palette.info.main,
  },
};

export const getStatusIcon = (
  documentStasus: VerificationStatus,
  props: any = {}
): JSX.Element => {
  if (documentStasus in statusIcons) {
    const Icon = statusIcons[documentStasus];
    return <Icon {...props} />;
  }

  return <></>;
};
